module.exports = __webpack_public_path__ + "img/t_revenue.a8d73916.svg";